var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZozhRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 131,
    viewBox: "0 0 211 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.67 124.94C89.3995 124.94 101.34 112.999 101.34 98.2696C101.34 83.5402 89.3995 71.5996 74.67 71.5996C59.9406 71.5996 48 83.5402 48 98.2696C48 112.999 59.9406 124.94 74.67 124.94Z",
    fill: "#A9E34B",
    stroke: "#A9E34B",
    strokeWidth: 1.255,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6698 71.5996C74.6698 71.5996 94.0198 96.6996 71.0098 124.94",
    stroke: "#74B816",
    strokeWidth: 1.255,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4102 89.3796C50.4102 89.3796 81.8201 72.6996 100.47 91.4996",
    stroke: "#74B816",
    strokeWidth: 1.255,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1804 76.5596C59.1804 76.5596 74.6904 78.9696 68.1404 91.4896C61.5904 104.01 55.7204 110.82 59.1804 119.97",
    stroke: "#74B816",
    strokeWidth: 1.255,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9696 78.9191C92.9696 78.9191 83.4496 78.3791 89.9096 91.4991C94.0196 99.8391 100.29 106.119 91.9296 118.669",
    stroke: "#74B816",
    strokeWidth: 1.255,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49 42.8399C101.49 40.9199 99.9404 39.3699 98.0204 39.3699C97.7804 39.3699 97.5503 39.3899 97.3203 39.4399C97.3203 39.4199 97.3303 39.3899 97.3303 39.3699C97.3303 37.0699 95.4604 35.1999 93.1604 35.1999C93.1604 32.8999 91.2904 31.0299 88.9904 31.0299C88.1204 31.0299 87.3104 31.2999 86.6404 31.7599C86.8004 31.3099 86.9104 30.8399 86.9104 30.3399C86.9104 28.0399 85.0404 26.1699 82.7404 26.1699C81.3204 26.1699 80.0604 26.8899 79.3104 27.9799C78.5704 27.2899 77.5804 26.8699 76.4904 26.8699C75.2004 26.8699 74.0604 27.4699 73.3004 28.3899C72.9904 28.3099 72.6603 28.2599 72.3203 28.2599C70.0203 28.2599 68.1504 30.1299 68.1504 32.4299C68.1504 34.7299 70.0203 36.5999 72.3203 36.5999C72.4003 36.5999 72.4803 36.5799 72.5703 36.5799C73.1403 38.2099 74.6704 39.3799 76.4904 39.3799C77.7004 39.3799 78.7804 38.8599 79.5404 38.0399C80.1304 39.6299 81.6403 40.7699 83.4403 40.7699C83.9903 40.7699 84.5104 40.6599 84.9904 40.4699C85.4704 42.2399 87.0704 43.5499 89.0004 43.5499C89.2704 43.5499 89.5204 43.5199 89.7704 43.4699C89.2904 44.0599 89.0004 44.8099 89.0004 45.6299C89.0004 47.5499 90.5503 49.0999 92.4703 49.0999C93.3603 49.0999 94.1604 48.7599 94.7804 48.2099C95.2704 49.5399 96.5304 50.4899 98.0304 50.4899C99.9504 50.4899 101.5 48.9399 101.5 47.0199C101.5 46.2299 101.23 45.5199 100.79 44.9399C101.22 44.3399 101.49 43.6299 101.49 42.8399Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3607 37.9802C82.2507 37.9802 83.0508 37.6402 83.6708 37.0902C84.1608 38.4202 85.4208 39.3702 86.9208 39.3702C87.1808 39.3702 87.4308 39.3402 87.6808 39.2802C87.8408 40.1602 88.3207 40.9202 89.0107 41.4402V41.4502C89.0107 43.3702 90.5607 44.9202 92.4807 44.9202C92.7507 44.9202 93.0208 44.8802 93.2708 44.8202C93.2108 45.0802 93.1708 45.3402 93.1708 45.6102C93.1708 47.5302 94.7207 49.0802 96.6407 49.0802C98.5607 49.0802 100.111 47.5302 100.111 45.6102C100.111 43.6902 98.5607 42.1402 96.6407 42.1402C96.3707 42.1402 96.1007 42.1802 95.8507 42.2402C95.9107 41.9802 95.9507 41.7202 95.9507 41.4502C95.9507 40.3202 95.4008 39.3202 94.5608 38.6902V38.6802C94.5608 36.7602 93.0107 35.2102 91.0907 35.2102C90.8307 35.2102 90.5807 35.2402 90.3307 35.3002C90.0407 33.6702 88.6308 32.4402 86.9208 32.4402C86.0308 32.4402 85.2307 32.7802 84.6107 33.3302C84.1207 32.0002 82.8607 31.0502 81.3607 31.0502C80.5407 31.0502 79.8007 31.3502 79.2007 31.8202C78.9207 30.5802 77.8207 29.6602 76.5007 29.6602C74.9707 29.6602 73.7207 30.9002 73.7207 32.4402C73.7207 33.9702 74.9607 35.2202 76.5007 35.2202C77.0207 35.2202 77.5008 35.0702 77.9208 34.8202",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3502 33.9001C75.0302 32.0101 73.2402 30.7401 71.3502 31.0601C69.4602 31.3801 68.1903 33.1701 68.5103 35.0601",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25 44.2304C70.25 44.2304 73.03 58.1104 69 60.2004C69 60.2004 69.55 62.9804 73.72 62.9804C73.72 62.9804 77.83 52.8304 84.13 52.5704C84.13 52.5704 95.67 51.5104 88.16 44.7504C80.66 37.9804 69.55 39.3704 70.25 44.2304Z",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0306 45.6201C73.0306 45.6201 73.3106 58.8101 71.6406 62.2801",
    stroke: "#74B816",
    strokeWidth: 1.3886,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1906 47.0098C77.1906 47.0098 72.5206 60.7698 71.6406 62.2798",
    stroke: "#74B816",
    strokeWidth: 1.3886,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6603 47.9795L73.0303 59.4995",
    stroke: "#74B816",
    strokeWidth: 1.3886,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1606 49.8896C83.1606 49.8896 73.9106 58.2096 71.6406 62.2796",
    stroke: "#74B816",
    strokeWidth: 1.3886,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3302 48.3897C97.3302 46.4697 95.7802 44.9197 93.8602 44.9197C93.6202 44.9197 93.3903 44.9397 93.1603 44.9897C93.1603 44.9697 93.1703 44.9397 93.1703 44.9197C93.1703 42.6197 91.3002 40.7497 89.0002 40.7497C89.0002 38.4497 87.1302 36.5797 84.8302 36.5797C83.9602 36.5797 83.1502 36.8497 82.4802 37.3097C82.6402 36.8597 82.7502 36.3897 82.7502 35.8897C82.7502 33.5897 80.8802 31.7197 78.5802 31.7197C77.1602 31.7197 75.9003 32.4397 75.1503 33.5297C74.4103 32.8397 73.4202 32.4197 72.3302 32.4197C71.0402 32.4197 69.9003 33.0197 69.1403 33.9397C68.8303 33.8597 68.5003 33.8097 68.1603 33.8097C65.8603 33.8097 63.9902 35.6797 63.9902 37.9797C63.9902 40.2797 65.8603 42.1497 68.1603 42.1497C68.2403 42.1497 68.3203 42.1297 68.4103 42.1297C68.9803 43.7597 70.5102 44.9297 72.3302 44.9297C73.5402 44.9297 74.6202 44.4097 75.3802 43.5897C75.9702 45.1797 77.4803 46.3197 79.2803 46.3197C79.8303 46.3197 80.3502 46.2097 80.8302 46.0197C81.3102 47.7897 82.9102 49.0997 84.8402 49.0997C85.1102 49.0997 85.3602 49.0697 85.6102 49.0197C85.1302 49.6097 84.8402 50.3597 84.8402 51.1797C84.8402 53.0997 86.3903 54.6497 88.3103 54.6497C89.2003 54.6497 90.0002 54.3097 90.6202 53.7597C91.1102 55.0897 92.3702 56.0397 93.8702 56.0397C95.7902 56.0397 97.3402 54.4897 97.3402 52.5697C97.3402 51.7797 97.0702 51.0697 96.6302 50.4897C97.0602 49.8997 97.3302 49.1797 97.3302 48.3897Z",
    fill: "#C0EB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1396 39.6403V32.6503L39.5096 34.1903L38.8296 27.7803L40.6996 29.4403L43.0796 19.9203L44.2697 23.4903L46.6497 16.3503L47.8396 19.9203C47.8396 19.9203 54.9797 13.9703 58.5497 15.1603C58.5497 15.1603 49.0297 21.1103 49.0297 23.4903H52.5996L48.3496 26.3303L50.2196 27.0603L44.2697 30.6303L48.3396 31.6103L40.6996 36.5803H44.2697L38.1396 39.6403Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8496 16.3504C22.8496 16.3504 29.9897 16.3504 31.1797 18.7304V15.6504L33.5597 22.3004L34.7496 21.1104V29.8904L37.0696 27.3304L36.5096 30.7204L35.9396 34.1904L37.0796 33.4504V39.6504L31.1896 31.8204H33.5696L28.8097 27.0604L32.3796 25.8704L27.6196 23.4904L29.9696 21.5804L22.8496 16.3504Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5995 41.3305L45.7395 38.7205H53.9495L51.3995 37.7605L57.3495 36.5705L54.9695 35.3805C54.9695 35.3805 58.5396 34.1905 58.5396 31.8105L51.7395 35.4205L50.7795 33.0005L49.0195 36.5705L47.8295 34.1905L44.2595 38.9505L45.4495 35.3805L40.6895 40.1405L49.5995 41.3305Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9395 40.1405L31.1796 33.0005L29.9595 35.4205L24.1495 31.8105V34.3705L16.8995 33.0005C16.8995 33.0005 19.3796 36.5705 19.9296 36.5705C20.4796 36.5705 14.5195 37.7605 14.5195 37.7605C14.5195 37.7605 25.2295 36.7805 25.2295 37.2705C25.2295 37.7605 22.8495 40.1405 22.8495 40.1405L27.6095 37.7605L27.7095 39.6405L31.1796 38.9405C31.1796 38.9405 30.3095 41.3205 30.7395 41.3205C31.1795 41.3305 35.9395 40.1405 35.9395 40.1405Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.319 87.7198V86.5298H40.009L41.869 71.0698H37.129V69.8798H42.009L43.729 55.6098H40.689V54.4198H43.869L44.619 48.1698C45.059 44.5398 42.2191 41.3398 38.5591 41.3398H37.689C34.029 41.3398 31.189 44.5398 31.629 48.1698L31.879 50.2598H37.109V51.4498H32.019L33.099 60.3698H38.2991V61.5598H33.239L35.099 77.0198H38.2891V78.2098H35.239L37.399 96.1498C37.499 96.9798 38.7091 96.9798 38.8091 96.1498L39.829 87.7298H38.319V87.7198Z",
    fill: "#A9E34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.65 24.3998L183.92 17.7998L180.58 25.1998L188.65 24.3998Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.05 14.99C156.77 14.99 156.48 14.88 156.26 14.66C155.83 14.23 155.83 13.52 156.26 13.09L158.3 11.05C158.73 10.62 159.44 10.62 159.87 11.05C160.3 11.48 160.3 12.19 159.87 12.62L157.83 14.66C157.62 14.88 157.34 14.99 157.05 14.99Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93 40.6299L173.97 50.3699",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.57 44.1504L174.65 58.9704",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5 118.5L192.75 105.36",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7904 124.999H2.42041C1.17041 124.999 0.150391 123.979 0.150391 122.729V73.4795H20.0604V122.739C20.0604 123.979 19.0404 124.999 17.7904 124.999Z",
    fill: "#D8F5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8103 68.34L19.0103 66.02C15.9003 65.35 12.8503 67.33 12.1803 70.43L7.2002 93.63",
    stroke: "#5C940D",
    strokeWidth: 1.171,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4202 123.24H2.80017C1.34017 123.24 0.160156 122.06 0.160156 120.6V87.5303H20.0701V120.6C20.0601 122.06 18.8702 123.24 17.4202 123.24Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54004 90.46V111.53",
    stroke: "#94D82D",
    strokeWidth: 1.171,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54004 114.46V117.97",
    stroke: "#94D82D",
    strokeWidth: 1.171,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.421 64.4102L150.091 78.3302L146.681 81.0802L140.391 72.4902L145.421 64.4102Z",
    fill: "#D8F5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.68 81.0802L146.83 86.2602L145.16 90.9902L150.98 88.0102L150.63 77.6602L149.03 75.9902L146.68 81.0802Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29 92.9504L147.89 93.1804C146.74 93.2904 145.67 92.5904 145.31 91.5004L145.25 91.3204L149.59 85.4104L150.45 77.6904C151.71 77.7404 152.74 78.7004 152.88 79.9504L153.46 85.0404L150.29 92.9504Z",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.52 53.2797C135.52 53.2797 128.23 65.1997 128.81 73.8997L138.26 77.3397L147.27 61.5497C147.27 61.5497 164 61.6497 161.31 49.4397C158.62 37.2297 135.52 53.2797 135.52 53.2797Z",
    fill: "#5C940D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88 13.9802L125.36 18.9102L122.76 14.1802H121.49L122.14 4.41016H134.78C134.79 4.41016 137.46 7.74016 135.88 13.9802Z",
    fill: "#D8F5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.62 52.5L116.771 53.28L119.08 54.99L135.84 54.21",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.64 6.22C117.86 6.13 117.56 5.17 118.14 4.65C120.11 2.88 124.05 0 128.8 0C132.49 0 135.08 0.87 136.69 1.67C137.93 2.29 138.58 3.66 138.25 5.01L137.83 6.78C137.58 7.81 136.6 8.49 135.55 8.35L124.51 6.88L118.64 6.22Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75 17.3504C127.75 17.3504 128.36 10.9504 126.86 7.19043",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.96 14.61C133.96 14.61 128.8 17.19 123.65 19.77C118.49 22.35 114.2 45.55 114.2 45.55C114.2 45.55 115.06 49.85 120.22 48.13L126.24 35.24C126.24 35.24 128.82 41.25 133.97 43.83L134.83 55L161.47 50.7C161.47 50.7 164.05 45.54 158.03 40.39L148.65 26.3L139.79 13.54L133.96 14.61Z",
    fill: "#82C91E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.85 39.5299C146.85 39.5299 151.73 42.9699 158.31 39.5299L160.53 35.8999C161.13 34.9099 161.42 33.7599 161.34 32.5999L160.82 24.7799C160.67 22.5599 159.77 20.4499 158.24 18.8399C154.54 14.9399 147.24 8.22986 141.7 9.45986C133.97 11.1799 134.83 15.4699 134.83 15.4699L146.85 39.5299Z",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59 29.2197L154.57 30.0797C154.57 30.0797 155.4 35.5397 148.11 39.6797",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.85 39.5305C146.85 39.5305 136.54 39.5305 133.96 43.8305L130.66 42.1005C136.74 34.8105 145.25 36.0205 145.25 36.0205",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.38 74.76L139.65 54.21",
    stroke: "#82C91E",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.28 76.4802C150.28 76.4802 152 70.4702 163.17 72.1802C174.34 73.9002 172.56 74.7602 172.56 74.7602L167.52 75.6202C167.53 75.6202 153.72 69.6002 150.28 76.4802Z",
    fill: "#74B816",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.851 75.6201L165.321 102.68L155.871 105.26",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.391 117.29L139.651 115.23L140.401 102.68L155.871 105.26L146.851 75.6195L141.301 72.5195",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88 82.4905L143.41 101.4L151.34 61.7305",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.641 92.3702L123.721 71.8702H127.081L130.091 59.7202L129.131 54.9902",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66 12.0296C129.66 12.0296 131.38 12.0296 132.24 10.3096C133.1 8.58957 131.53 7.80957 131.53 7.80957",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.521 7.73047C130.521 7.73047 127.231 8.67047 125.871 9.92047C124.511 11.1705 122.791 11.1705 121.931 10.3105C121.921 10.3005 121.911 10.2905 121.901 10.2805C121.321 9.67047 121.661 8.65047 122.471 8.44047C123.661 8.13047 126.321 7.97047 128.801 7.73047",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86 45.7401L112.48 53.2701L111.15 54.9901C111.15 54.9901 110.76 57.1301 115.05 56.7101L117.63 55.8501C117.63 55.8501 117.63 56.7101 119.35 56.7101C122.07 56.7101 116.77 53.2701 116.77 53.2701L119.72 46.9501L118.52 46.1501C117.44 45.4401 116.07 45.2801 114.86 45.7401Z",
    fill: "#D8F5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.181 125.091C170.497 124.016 174.068 114.043 172.157 102.817C170.246 91.5907 163.577 83.3613 157.261 84.4363C150.946 85.5113 147.375 95.4836 149.286 106.71C151.197 117.936 157.866 126.166 164.181 125.091Z",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.393 128.824C173.266 127.484 177.807 115.58 175.535 102.236C173.264 88.8917 165.041 79.1603 157.168 80.5004C149.295 81.8404 144.754 93.7444 147.026 107.089C149.297 120.433 157.521 130.164 165.393 128.824Z",
    stroke: "#74B816",
    strokeWidth: 2.4312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34 104.89C128.79 105.22 128.2 105.44 127.57 105.55C123.09 106.31 118.44 100.91 117.17 93.4802C115.91 86.0502 118.51 79.4102 122.99 78.6502C124.38 78.4102 125.79 78.7702 127.11 79.6002",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44 107.88C128.76 108.3 128.03 108.59 127.25 108.72C121.93 109.63 116.37 103.05 114.83 94.02C113.29 84.99 116.37 76.95 121.69 76.04",
    stroke: "#74B816",
    strokeWidth: 2.4312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.31 110.17L138.18 113.52C138.93 114.39 138.67 115.74 137.64 116.26L132.01 119.12C130.46 119.9 128.78 120.38 127.05 120.53L123.2 120.85C122.17 120.94 121.69 119.59 122.55 119.01L127.75 115.5L129.44 111.39",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 54.9902C121.44 54.9902 117.63 67.0202 127.09 71.3202",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.94 65.3097C127.94 65.3097 129.84 61.1697 119.44 54.2197",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.71 55.4199C125.71 55.4199 121.92 62.7699 127.08 67.8999",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47 53.2803L108.28 54.1003C107.94 54.1703 107.74 54.5103 107.84 54.8403C108.04 55.4603 108.59 55.9003 109.24 55.9503L111.61 56.1403",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75 17.3498L135.5 8.33984",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.221 35.2299C126.221 35.2299 127.881 31.2499 127.751 28.4699C127.621 25.6899 128.081 38.4699 128.081 38.4699L126.221 35.2299Z",
    fill: "#74B816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.141 11.2598C137.141 11.2598 154.641 22.8998 148.121 39.1798",
    stroke: "#74B816",
    strokeWidth: 1.2156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.26 61.5498C147.26 61.5498 157.48 61.0098 159.26 57.6298C160.37 55.5298 156.24 55.7098 152.95 56.1398C150.69 56.4398 148.76 57.9298 147.89 60.0398L147.26 61.5498Z",
    fill: "#82C91E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.18 113.52L138.74 114.95C139.23 116.2 138.56 117.6 137.27 117.99L130.95 119.91C130.09 120.17 129.21 120.34 128.32 120.41L123.2 120.84C123.2 120.84 135.36 118.69 138.18 113.52Z",
    fill: "#94D82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.96 77.3504L128.81 73.9004L127.09 79.0604L129.45 111.39L129.7 111.52C131.02 112.18 132.61 112 133.76 111.06L134.11 110.77C134.11 110.77 137.95 97.4104 137.04 91.3304C136.13 85.2504 135.5 82.4904 135.5 82.4904L137.96 77.3504Z",
    fill: "#D8F5A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79 8.87988L87.6201 21.5799",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.999 74.8161L180.556 78.5361L184.276 84.9792L190.719 81.2591L186.999 74.8161Z",
    stroke: "#A9E34B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZozhRightImage);
export default __webpack_public_path__ + "static/media/zozhRightImage.4de96a43e936a704e5ac7b7ebea3044b.svg";
export { ForwardRef as ReactComponent };